import React from "react";

// Styles
import Styles from "./errorMessage.module.scss";

function ErrorMessage({ ...props }: any) {
  return (
    <p
      id={`error-msg-${props.testId}`}
      className={`${Styles.errorText} pt-2 pb-2 pr-2 mb-0`}
      data-testid={props.testId}
    >
      {props.children}
    </p>
  );
}

export default ErrorMessage;
